export enum PrivacyTypesEnum {
	Public = '48c3ebc3-4668-4bc9-85fc-598e54b4ce7b',
	OnlyPals = '311a4dfc-df7c-4eab-a878-48919a7634d8',
	OnlyMe = '8efa6217-a36f-4b5a-bd26-d84856444be3', // TODO rename to private or unlisted
}
